import { useEffect, useState } from 'react'
import { minutesLeft } from '../model/state'

export interface ImpersonationBannerProps {
  clinicName: string
  superAdminName: string
  inactive: boolean
  expiresAt: string
  onExit: () => void
  exiting?: boolean
}

/** The countdown refreshes every 30 s; "Ends in {N} min" is quiet (Frontend §6.4 step 5). */
const TICK_MS = 30_000

/**
 * The impersonation banner (UserFlows §4.4, Frontend §6.4 step 5): sticky above the shell on every page, can't be
 * dismissed. "You're viewing {Clinic} as {Super admin name} (super admin) · Exit", "(inactive clinic)" for a
 * deactivated clinic (S-06), and a quiet "Ends in {N} min".
 */
export function ImpersonationBanner({
  clinicName,
  superAdminName,
  inactive,
  expiresAt,
  onExit,
  exiting = false,
}: ImpersonationBannerProps) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => {
      setNow(Date.now())
    }, TICK_MS)
    return () => {
      clearInterval(t)
    }
  }, [])
  const left = minutesLeft(expiresAt, now)
  return (
    <div className="imp-banner" role="region" aria-label="Impersonation">
      <span className="imp-text">
        You&apos;re viewing <b>{clinicName}</b>
        {inactive && <span className="imp-inactive"> (inactive clinic)</span>} as <b>{superAdminName}</b> (super admin)
        <span aria-hidden> · </span>
        <button type="button" className="imp-exit" onClick={onExit} disabled={exiting}>
          Exit
        </button>
      </span>
      <span className="imp-ends">Ends in {left} min</span>
    </div>
  )
}
